import {
    subscriptionCancelPlan,
    subscriptionUpdatePlan,
} from '@nesso/subscription-contracts/subscription.commands';
import {
    cancellationFeedbackSchema,
    subscriptionStatusSchema,
} from '@nesso/subscription-contracts/subscription.models';
import {
    subscriptionUpdatedNotificationSchema,
    trialSubscriptionStartedNotificationSchema,
} from '@nesso/subscription-contracts/subscription.notifications';
import {
    getSubscriptionMe,
    getSubscriptionUsageHistory,
    listPaidPlans,
} from '@nesso/subscription-contracts/subscription.queries';

export { subscriptionStatusSchema, trialSubscriptionStartedNotificationSchema };
export const subscriptionMeSchema = getSubscriptionMe.output;
export const subscriptionUsageHistorySchema = getSubscriptionUsageHistory.output;

export { cancellationFeedbackSchema, subscriptionUpdatedNotificationSchema };

export const cancelPlanInputSchema = subscriptionCancelPlan.input;
export const listPaidPlansOutputSchema = listPaidPlans.output;
export const updatePlanInputSchema = subscriptionUpdatePlan.input;
export const updatePlanOutputSchema = subscriptionUpdatePlan.output;
